import React, { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  Collapse,
  ListItem,
  Typography,
  fade,
  makeStyles
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';
import Rules from 'src/Rules.json'

const useStyles = makeStyles(theme => ({
  item: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0
  },
  itemLeaf: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    padding: '8px 7px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%'
  },
  buttonLeaf: {
    color: theme.palette.text.secondary,
    padding: '8px 7px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    '&:hover': {
      backgroundColor: Rules.nav_top_bar.navbar_button_hover
    },
    fontWeight: theme.typography.fontWeightRegular,
    '&.depth-0': {
      '& $title': {
        // fontWeight: theme.typography.fontWeightMedium
      }
    }
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(3)
  },
  title: {
    color: Rules.nav_top_bar.navbar_text_color,
    marginRight: 'auto'
  },
  active: {
    color: Rules.nav_top_bar.navbar_text_color,
    '& $title': {
      // fontWeight: theme.typography.fontWeightMedium
    },
    '& $icon': {
      color: Rules.nav_top_bar.navbar_text_color
    },
    background: Rules.nav_top_bar.navbar_button_hover
  }
}));

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: NavIcon,
  info: Info,
  open: openProp,
  navOpen,
  title,
  ...rest
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };
  console.log(navOpen);
  if (children) {
    return (
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button className={classes.button} onClick={handleToggle} style={style}>
          {NavIcon && (
            <Icon
              icon={NavIcon}
              style={{
                fontSize: '25px',
                marginRight: '0px',
                marginBottom: '0px',
                color:Rules.nav_top_bar.navbar_text_color
              }}
            />
          )}
          <Typography variant="body2" className={classes.title} sx={{ opacity: navOpen ? 1 : 0  }}>
            {title}
          </Typography>
          {open ? (
            <Icon
              icon="material-symbols-light:expand-less-rounded"
              style={{
                fontSize: '25px',
                marginRight: '0px',
                marginBottom: '0px',
                color:Rules.nav_top_bar.navbar_text_color
              }}
            />
          ) : (
            <Icon
              icon="material-symbols-light:expand-more-rounded"
              style={{
                fontSize: '25px',
                marginRight: '0px',
                marginBottom: '0px',
                color:Rules.nav_top_bar.navbar_text_color
              }}
            />
          )}
        </Button>

        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem
      className={clsx(classes.itemLeaf, className)}
      disableGutters
      key={title}
      {...rest}
    >
      <Button
        activeClassName={classes.active}
        className={clsx(classes.buttonLeaf, `depth-${depth}`)}
        component={RouterLink}
        style={style}
        to={href}
      >
        {NavIcon && (
          <Icon
            icon={NavIcon}
            style={{
              fontSize: '25px',
              marginRight: '10px',
              marginBottom: '2px',
              color:Rules.nav_top_bar.navbar_text_color
            }}
          />
        )}
        <Typography variant="body2" className={classes.title} sx={{ opacity: navOpen ? 1 : 0 }}>
          {title}
        </Typography>
        {Info && <Info />}
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired
};

NavItem.defaultProps = {
  open: false
};

export default NavItem;
